import { Component, output } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from '@jsverse/transloco';
import { QaiAvatarComponent, QaiButtonComponent, QaiCallButtonComponent, QaiIconComponent } from '@qai/ui';
import { PathwayRoleplayFooterService } from '../services/pathway-roleplay-footer.service';
import { RoleplayFooterState } from '../services/pathway-roleplay.service';

@Component({
  selector: 'app-roleplay-call-footer',
  standalone: true,
  templateUrl: './roleplay-footer.component.html',
  styleUrls: ['./roleplay-footer.component.css'],
  imports: [
    MatTooltipModule,
    QaiAvatarComponent,
    QaiButtonComponent,
    QaiCallButtonComponent,
    QaiIconComponent,
    TranslocoModule,
  ],
})
export class RoleplayCallFooterComponent {
  readonly launchSimulationClicked = output<void>();
  readonly resultActionClicked = output<void>();
  readonly endCallClicked = output<void>();

  constructor(public readonly footerService: PathwayRoleplayFooterService) {}

  protected onActionClick(): void {
    const state = this.footerService.state();
    if (state === RoleplayFooterState.Result) this.resultActionClicked.emit();
    else if (state === RoleplayFooterState.Preamble) this.launchSimulationClicked.emit();
    else this.endCallClicked.emit();
  }

  protected onCaptionsClick(): void {
    this.footerService.onCaptionsClick();
  }

  protected onMicrophoneClick(): void {
    this.footerService.onMicrophoneClick();
  }

  protected onVideoClick(): void {
    this.footerService.onVideoClick();
  }
}
